import { HttpClient, HttpContext, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiConfiguration } from '@/core/api/api-configuration';
import { BaseService } from '@/core/api/base-service';
import { PrestadorDocumentosRequest, PrestadorDocumentosResponse } from '@/core/api/sicom-api/registro/prestador/prestador-documentos.model';
import { Pessoa } from '@/shared/models/pessoa-info.model';
import { environment } from '@env/environment';
import { SICOM_PATHS } from 'src/sicom-paths';

@Injectable({ providedIn: 'root' })
export class PrestadorDocumentosService extends BaseService {
    readonly PATH = SICOM_PATHS.registro.prestador.documentos;

    constructor(config: ApiConfiguration, http: HttpClient) {
        super(config, http, environment.apis.apiSicom);
    }

    buscar(params: Pessoa, context?: HttpContext): Observable<PrestadorDocumentosResponse> {
        const httpParams = new HttpParams().set('id', String(params.id)).set('uf', String(params.uf));
        return this.http.get<PrestadorDocumentosResponse>(this.PATH, { params: httpParams, context });
    }

    atualizar(body: PrestadorDocumentosRequest, context?: HttpContext): Observable<PrestadorDocumentosResponse> {
        return this.http.put<PrestadorDocumentosResponse>(this.PATH, body, { context });
    }
}
